import { render, staticRenderFns } from "./MdtMailPreview.vue?vue&type=template&id=6090cf98&scoped=true"
import script from "./MdtMailPreview.vue?vue&type=script&lang=js"
export * from "./MdtMailPreview.vue?vue&type=script&lang=js"
import style0 from "./MdtMailPreview.vue?vue&type=style&index=0&id=6090cf98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6090cf98",
  null
  
)

export default component.exports